import { render, staticRenderFns } from "./NewsBanner.vue?vue&type=template&id=6f13c94f"
import script from "./NewsBanner.vue?vue&type=script&lang=js"
export * from "./NewsBanner.vue?vue&type=script&lang=js"
import style0 from "./NewsBanner.vue?vue&type=style&index=0&id=6f13c94f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports